"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Settings = function Settings(api, data) {
  (0, _classCallCheck3.default)(this, Settings);

  Object.assign(this, (0, _extends3.default)({ api: api }, data));
};

Settings._namespace = "settings";

Settings.getLatestVersion = function (api, instance) {
  return api.getObject(Settings, "settings/dataupdate?instance=" + instance + "&version=0&is_device=0");
};

Settings.createVersion = function (api, instance) {
  var postVersionData = { "message": "Saved via HRI", "update_for_device": false, "instance": "" };
  postVersionData.instance = instance;
  api.postObject(Settings, "settings/dataupdate", postVersionData);
};

Settings.getDatapackage = function (api, instance, version) {
  return api.getObject(Settings, "settings/datapackage?instance=" + instance + "&version=" + version);
};

exports.default = Settings;


//////////////////
// WEBPACK FOOTER
// ../sdk/lib/Settings.js
// module id = 320
// module chunks = 0